import styled from 'styled-components';

export const ControlsSC = styled.div`
  width: 380px;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50px;
  padding-right: 15px;
  padding-left: 15px;
  z-index: 99998;

  left: 0;
  right: 0;

  margin-left: auto;
  margin-right: auto;

  svg {
    width: 50px;
    height: 50px;
    cursor: pointer;
  }
`;
